var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "registor" } }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "login-box", attrs: { align: "center" } }, [
        _c("h1", { staticClass: "main-text", attrs: { align: "center" } }, [
          _vm._v("\n            使用券码并下载应用\n            "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "sub-text" }, [
          _vm._v("\n                激活码已成功绑定到 "),
          _c(
            "span",
            { staticStyle: { color: "#f7419c", "font-weight": "500" } },
            [_vm._v(_vm._s(_vm.$store.getters.getEmail))]
          ),
          _vm._v(" 账号。"),
          _c("br"),
          _vm._v(
            "\n                请使用该都都英语账号登录App。\n            "
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "coupon-bg" }, [
          _c("p", [_vm._v(_vm._s(_vm.code))]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }